import React, { Component } from "react";
import { routes } from "../General";
import axios from "axios";
import "moment/locale/es";
import { Modal, ModalBody } from "reactstrap";
import { Contratante } from "./Contratante";
import ReactTable from "react-table";
import { formatMoney } from "../../coms/siniestros/Deducibles";

export class Detalles extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            list: [],
            dependientes: [],
            pages: -1,
            page: 0,
            loading: false,
            tipo: 1, //por defecto vehiculo
            columns: [],
            selected: -1,
        };
    }

    componentDidMount() {
        let { open } = this.props;
        if (open) {
            this.fetchData();
            this.tipoContenido();
        }
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
                this.tipoContenido();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    tipoContenido() {
        let item = this.props.item;
        axios
            .get(routes.api + "/polizas/tipo-contenido", { params: { cdRamoCotizacion: item.cdRamoCotizacion } })
            .then(resp => {
                let ramo = resp.data;
                let tipo;
                if (ramo != null && (ramo.nmRamo.includes("VIDA") || ramo.nmRamo.includes("MEDICA"))) {
                    tipo = 2;
                } else if (ramo != null && ramo.nmRamo.includes("VEHICULO")) {
                    tipo = 1;
                } else {
                    tipo = 0;
                }
                this.setState({ tipo: tipo, columns: this.generateColumns(tipo) });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    }

    fetchData = query => {
        let { item, poliza } = this.props;
        axios
            .post(routes.api + "/polizas/objeto", {
                cdRamoCotizacion: item.cdRamoCotizacion,
                cdRamo: poliza.cdRamo,
                cdCompania: item.compania.cdCompania,
                cdUbicacion: item.cdRamoCotizacion, //busco ubicacion x ramoCotizacion
                dscObjeto: "",
                cedulaO: "",
                page: query ? query.page : 0,
                pageSize: query ? query.pageSize : 10,
                sorted: [],
                vehiculo: {
                    marca: "",
                    modelo: "",
                    placa: "",
                    noDeMotor: "",
                    noDeChasis: "",
                },
            })
            .then(resp => {
                let list = resp.data;
                this.setState({
                    list: list.content,
                    pages: list.totalPages,
                    loading: false,
                });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getObjetos(item) {
        axios
            .get(routes.api + "/polizas/subobjetos", {
                params: {
                    cdCompania: item.cdCompania,
                    cdObjetoCotizacion: item.cdObjCotizacion,
                },
            })
            .then(resp => {
                let list = resp.data;
                this.setState({ dependientes: list });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    }

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ list: [] });
    };

    generateColumns(tipo) {
        if (tipo === 1) {
            return [
                {
                    Header: "Item",
                    minResizeWidth: 50,
                    width: 140,
                    accessor: "item",
                },
                {
                    Header: "Objeto Asegurado",
                    minResizeWidth: 50,
                    width: 200,
                    accessor: "dscObjeto",
                },
                {
                    id: "totAseActual",
                    Header: "Val Aseg($)",
                    accessor: val => {
                        return formatMoney(val.totAseActual);
                    },
                    minResizeWidth: 10,
                    width: 100,
                },
                {
                    id: "tasa",
                    Header: "Tasa",
                    accessor: t => {
                        return t.tasa + "%";
                    },
                    minResizeWidth: 10,
                    width: 100,
                },
                {
                    id: "totPriActual",
                    Header: "Prima ($)",
                    minResizeWidth: 10,
                    accessor: pri => {
                        return formatMoney(pri.totPriActual);
                    },
                    width: 140,
                },
                {
                    Header: "ItemASeg",
                    minResizeWidth: 10,
                    accessor: "itemAseg",
                    width: 160,
                },
                {
                    Header: "Marca",
                    minResizeWidth: 10,
                    accessor: "vehiculo.marca",
                    width: 140,
                },
                {
                    Header: "Modelo",
                    minResizeWidth: 10,
                    accessor: "vehiculo.modelo",
                },
                {
                    Header: "Año",
                    minResizeWidth: 10,
                    accessor: "vehiculo.anioDeFabricacion",
                },
                {
                    Header: "Placa",
                    minResizeWidth: 10,
                    accessor: "vehiculo.placa",
                },
                {
                    Header: "Motor",
                    minResizeWidth: 10,
                    width: 150,
                    accessor: "vehiculo.noDeMotor",
                },
                {
                    Header: "Chasis",
                    minResizeWidth: 10,
                    width: 150,
                    accessor: "vehiculo.noDeChasis",
                },
                {
                    Header: "Color",
                    minResizeWidth: 10,
                    accessor: "vehiculo.color",
                },
                {
                    Header: "Observaciones",
                    minResizeWidth: 10,
                    accessor: "obsObjeto",
                },
            ];
        } else {
            return [
                {
                    Header: "Item",
                    minResizeWidth: 50,
                    width: 140,
                    accessor: "item",
                },
                {
                    Header: "Ubicación",
                    minResizeWidth: 50,
                    width: 200,
                    accessor: "ubicacion.dscUbicacion",
                },
                {
                    Header: "Objeto Asegurado",
                    minResizeWidth: 50,
                    width: 200,
                    accessor: "dscObjeto",
                },
                {
                    Header: "Embarque",
                    accessor: "trayecto",
                    minResizeWidth: 10,
                    width: 100,
                },
                {
                    Header: "Destino",
                    accessor: "trHasta",
                    minResizeWidth: 10,
                    width: 100,
                },
                {
                    id: "totAseActual",
                    Header: "Val Asegurado ($)",
                    minResizeWidth: 10,
                    accessor: val => {
                        return formatMoney(val.totAseActual);
                    },
                    width: 140,
                },
                {
                    id: "tasa",
                    Header: "Tasa",
                    minResizeWidth: 10,
                    accessor: t => {
                        return t.tasa + "%";
                    },
                    width: 160,
                },
                {
                    id: "totPriActual",
                    Header: "Prima ($)",
                    minResizeWidth: 10,
                    accessor: pri => {
                        return formatMoney(pri.totPriActual);
                    },
                    width: 140,
                },
                {
                    Header: "Observaciones",
                    minResizeWidth: 10,
                    accessor: "obsObjeto",
                },
            ];
        }
    }

    render() {
        let { columns } = this.state;
        let ramos = this.props.ramos;

        return (
            <Modal className="text-center modal-xl mx-auto modal-detail" isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante
                            poliza={this.props.poliza}
                            item={this.props.item}
                            user={this.props.user}
                            vida={this.props.vida}
                            ramos={ramos}
                        />
                        <div className="col-lg-9 pt-2">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={() => {
                                        this.closeModal();
                                        this.setState({ dependientes: [] });
                                    }}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <h5 className="card-title">Detalle Póliza</h5>
                            <ReactTable
                                noDataText={"No se han encontrado pólizas"}
                                previousText={"Anterior"}
                                nextText={"Siguiente"}
                                pageText={"Página"}
                                rowsText={"filas"}
                                ofText={"de"}
                                columns={columns}
                                getTdProps={(state, rowInfo) => {
                                    if (rowInfo && rowInfo.row) {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                this.getObjetos(rowInfo.original);
                                                this.setState({ selected: rowInfo.index });
                                                if (handleOriginal) {
                                                    handleOriginal();
                                                }
                                            },
                                            style: {
                                                cursor: "pointer",
                                                color:
                                                    rowInfo.index === this.state.selected
                                                        ? "white"
                                                        : rowInfo.original.activo
                                                          ? "black"
                                                          : "red",
                                                height: 45,
                                            },
                                            className: rowInfo.index === this.state.selected ? "bg-primary" : "",
                                        };
                                    } else {
                                        return [];
                                    }
                                }}
                                manual
                                data={this.state.list}
                                pages={this.state.pages}
                                loading={this.state.loading}
                                onFetchData={this.fetchData}
                                defaultPageSize={10}
                                className="-striped -highlight"
                                page={this.state.page}
                                pageSize={this.state.pageSize}
                                onPageChange={page => this.setState({ page })}
                                onPageSizeChange={(pageSize, page) => this.setState({ page, pageSize })}
                            ></ReactTable>
                            <br />

                            <h5 className="card-title">Extras</h5>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead className="text-primary">
                                        <tr>
                                            <th className="text-left">Item</th>
                                            <th className="text-right">Valor Asegurado($)</th>
                                            <th className="text-right">Tasa</th>
                                            <th className="text-right">Prima($)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.dependientes.length === 0 ? (
                                            <React.Fragment>
                                                <tr>
                                                    <td colSpan={4}>
                                                        <span>No hay información disponible.</span>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                {this.state.dependientes.map((item, index) => (
                                                    <tr key={item.cdSubObjeto}>
                                                        <td>
                                                            <span>{item.dscSubobjeto}</span>
                                                        </td>
                                                        <td className="text-right">
                                                            <span>{formatMoney(item.totAseActual)}</span>
                                                        </td>
                                                        <td className="text-right">
                                                            <span>{item.tasa + "%"}</span>
                                                        </td>
                                                        <td className="text-right">
                                                            <span>{formatMoney(item.totPriActual)}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
